import React from "react"
import { navigationItemArrow } from "../../../../../../../static/svgs/navigation"

type Props = {
  children: React.ReactNode
  isOpen: boolean
}

const ListItemContent = ({ children, isOpen }: Props) => (
  <div className="items-center justify-between gap-2 flex">
    <div>
      <span className="text-white font-raleway-semibold font-semibold text-2xl">
        {children}
      </span>
    </div>
    <div>
      <img
        alt="arrow"
        className={`transition-transform ${isOpen ? "rotate-180" : ""}`}
        src={navigationItemArrow}
      />
    </div>
  </div>
)

export default ListItemContent
